import React from 'react';

export default function TermsOfService() {
  return (
    <div dir="rtl" className="min-h-screen bg-[#e8e9eb]" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <div className="font-cairo max-w-4xl mx-auto px-6 py-20">
        {/* Header */}
        <div className="bg-[#141d3c] text-white px-12 py-10 rounded-lg mb-8 mt-[100px] shadow-lg text-center">
          <h1 className="text-3xl font-bold mb-3">شـروط الإستخدام – زان التسويقية الرقمية</h1>
          <p className="text-white/70"> 1 يناير 2026</p>
        </div>

        {/* Content */}
        <div className="bg-white px-12 py-10 rounded-lg shadow-sm">
          <div className="text-black/80 leading-loose space-y-8">
            {/* Introduction */}
            <p className="text-base">
              مرحبًا بكم في زان. من خلال استخدامك لخدماتنا، بما في ذلك التسويق الرقمي، المطبوعات، الدعاية والإعلان، تنظيم الحفلات والفعاليات، فإنك توافق على الالتزام بالشروط والأحكام التالية. يرجى قراءة هذه الشروط بعناية قبل طلب أي خدمة من زان، حيث أن طلب الخدمة والدفع يعني قبولك الكامل والمباشر بهذه الشروط.
            </p>

            {/* Section 1 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">1. نطاق الخدمات</h2>
              <p className="mb-3">زان تقدم خدمات متنوعة للأفراد والشركات تشمل:</p>
              <ul className="space-y-1.5 mr-6 mb-3">
                <li>• التسويق الرقمي والإعلانات عبر الإنترنت.</li>
                <li>• المطبوعات بجميع أنواعها.</li>
                <li>• تصميم وتنفيذ الحملات الدعائية.</li>
                <li>• تنظيم الحفلات والفعاليات والأيفينتات.</li>
              </ul>
              <p>جميع الخدمات يتم تنفيذها وفقًا لمتطلبات العميل وبناءً على طلبه، مع مراعاة معايير الجودة المهنية التي تتبعها زان.</p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">2. العملاء</h2>
              <p className="mb-3">تتعامل زان مع:</p>
              <ul className="space-y-1.5 mr-6 mb-3">
                <li>• الشركات والمؤسسات.</li>
                <li>• الأفراد.</li>
              </ul>
              <p>وتلتزم زان بتقديم الخدمات بنفس المعايير لجميع العملاء دون أي تمييز.</p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">3. الدفع</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• جميع المدفوعات تتم مقدمًا قبل بدء تنفيذ أي خدمة.</li>
                <li>• بمجرد الدفع، يعتبر العميل قد وافق على جميع شروط الخدمة بشكل كامل وملزم قانونيًا.</li>
              </ul>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">4. تنفيذ الخدمات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• جميع الخدمات يتم تنفيذها حسب طلب العميل ووفق مواصفاته.</li>
                <li>• بعد اكتمال الخدمة وتسليمها، تصبح ملكية العمل للعميل، مع الاحتفاظ بحق زان في أن ينسب لها التنفيذ عند عرض الأعمال بشكل عام أو في معرض أعمالها.</li>
              </ul>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">5. الملكية والاستخدام</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• ملكية أي عمل يتم تنفيذه للعميل تنتقل إليه بعد الدفع.</li>
                <li>• لا يحق نسب التنفيذ للعميل، حيث تظل زان هي المنفذة الفعلية للخدمة.</li>
                <li>• لا تتحمل زان أي مسؤولية إذا قام العميل بإعادة بيع أو استخدام الخدمات لأغراض تجارية أو غير مشروعة.</li>
              </ul>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">6. السرية وحماية البيانات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• تلتزم زان بالحفاظ على سرية جميع بيانات العملاء والمعلومات المقدمة لها، وتعتبر حماية العميل وأمان معلوماته من أولوياتها القصوى.</li>
                <li>• لا يتم مشاركة أي معلومات مع أطراف ثالثة دون موافقة العميل، إلا إذا اقتضت الضرورة القانونية.</li>
              </ul>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">7. الاستخدام الضار للخدمات</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• زان غير مسؤولة عن أي استخدام ضار أو غير قانوني للخدمات بعد تسليمها للعميل.</li>
                <li>• العميل يتحمل كامل المسؤولية عن أي أفعال أو نتائج تنتج عن استخدامه للخدمات.</li>
              </ul>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">8. التحديثات على الشروط</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• تحتفظ زان بحق تعديل أو تحديث هذه الشروط في أي وقت دون الحاجة لإخطار العملاء بشكل مسبق.</li>
                <li>• استمرار استخدام العميل للخدمات بعد أي تحديث يعتبر قبولًا ضمنيًا بالشروط المعدلة.</li>
              </ul>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">9. القانون والاختصاص القضائي</h2>
              <ul className="space-y-1.5 mr-6">
                <li>• تخضع هذه الشروط وتفسر وفقًا للقوانين المعمول بها في المملكة العربية السعودية.</li>
                <li>• أي نزاع ينشأ بين العميل وزان سيتم حله ضمن اختصاص المحاكم السعودية المختصة.</li>
              </ul>
            </div>

            {/* Section 10 */}
            <div>
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">10. الاتصال والدعم</h2>
              <p className="mb-2">يمكنك التواصل مع زان لأي استفسار أو دعم عبر:</p>
              <ul className="space-y-1.5 mr-6">
                <li>• الهاتف: <span dir="ltr">+966 57 937 9779</span></li>
                <li>• البريد الإلكتروني: info@zan-mkt.com</li>
              </ul>
            </div>

            {/* Section 11 */}
            <div className="pt-6 border-t-2 border-[#e8e9eb]">
              <h2 className="text-xl font-bold text-[#141d3c] mb-3">11. الموافقة</h2>
              <p>بالطلب والدفع، يقر العميل بأنه قرأ وفهم جميع الشروط والأحكام، وأنه ملتزم بها بشكل كامل وملزم قانونيًا.</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        
      </div>
    </div>
  );
}